<template>
  <v-container id="pacote-list">
    <v-row>
      <v-col>Contratos</v-col>
      <v-col class="text-right">
        <app-modal-insert-eixo
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          @on-save="loadPacotes"
        >
          <template v-slot:title :edit="false">
            Cadastro de Contratos
          </template>
        </app-modal-insert-eixo>
      </v-col>
    </v-row>

    <v-row class="d-flex align-center">
      <v-col>
        <v-text-field
          label="N° do contrato"
          name="nome"
          type="text"
          outlined
          clearable
          hide-details="auto"
          v-model="filtro.numContrato"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="filtro.inicio"
          v-mascara="'##/##/####'"
          label="Início a partir de"
          outlined
          clearable
          placeholder="00/00/0000"
          hide-details="auto"
        ></v-text-field>
      </v-col>
      até
      <v-col>
        <v-text-field
          v-model="filtro.fim"
          v-mascara="'##/##/####'"
          label="Fim antes de"
          outlined
          clearable
          placeholder="00/00/0000"
          hide-details="auto"
        ></v-text-field>
      </v-col>

      <v-col>
        <ComboboxUser ref="user" :filter="filtro" outlined></ComboboxUser>
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="filtro.situacao"
          :items="situacao"
          label="Situação"
          outlined
          placeholder="Selecione..."
          v-on:change="$emit('onChange')"
          :clearable="true"
          :return-object="true"
          hide-details="auto"
        >
        </v-autocomplete>
      </v-col>
      <v-col>
        <v-btn color="primary" class="ml-3" @click="filtrarContratos()">
          <span>Filtrar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col>
                <app-modal-insert-eixo
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @on-save="loadPacotes"
                >
                  <template v-slot:title> Edição de Contratos </template>
                </app-modal-insert-eixo>
              </v-col>
              <v-col>
                <app-modal-delete :object="item" @on-save="loadPacotes">
                  <template v-slot:title>
                    {{ item.ativo ? "Inativar" : "Reativar" }} Contrato
                  </template>
                </app-modal-delete>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.inicio="{ item }">
            {{ item.inicio | moment("DD/MM/YYYY") }}
          </template>
          <template v-slot:item.fim="{ item }">
            {{ item.fim | moment("DD/MM/YYYY") }}
          </template>

          <template v-slot:item.ativo="{ item }">
            <div
              :class="{
                ativo: item.ativo,
                inativo: !item.ativo,
                status: true,
              }"
            >
              {{ item.ativo ? "Ativo" : "Inativo" }}
            </div>
          </template>
          <template slot="no-data">
            <span> Nenhum Contrato retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertEixo from "./ModalInsert";
import { mapActions, mapGetters } from "vuex";
import AppModalDelete from "./../components/ModalStatus";
import moment from "moment";
import { contratosAPI } from "@/apis";
import ComboboxUser from "@/modules/user/components/ComboboxUsers";

export default {
  components: {
    AppModalInsertEixo,
    AppModalDelete,
    ComboboxUser,
  },
  data() {
    return {
      headers: [
        { text: "N° Contrato", value: "numContrato" },
        { text: "Inicio", value: "inicio", sortable: false },
        { text: "Fim", value: "fim", sortable: false },
        { text: "Responsável", value: "usuario.nome", sortable: false },
        { text: "Situação", value: "ativo", sortable: false },
        { text: "Ações", value: "acoes", sortable: false },
      ],
      payload: [],
      situacao: ["Ativo", "Inativo"],
      todosContratos: [],
      filtro: {
        numContrato: null,
        inicio: null,
        fim: null,
        situacao: null,
        usuario: null,
      },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    filtrarContratos() {
      this.payload = this.todosContratos;

      if (this.filtro.numContrato) {
        this.payload = this.payload.filter((item) =>
          item.numContrato.includes(this.filtro.numContrato)
        );
      }

      if (this.filtro.inicio && this.filtro.fim) {
        this.payload = this.payload.filter(
          (item) =>
            moment(item.inicio).isSameOrAfter(
              moment(this.filtro.inicio, "DD/MM/YYYY")
            ) &&
            moment(item.fim).isSameOrBefore(
              moment(this.filtro.fim, "DD/MM/YYYY")
            )
        );
      } else if (this.filtro.inicio) {
        this.payload = this.payload.filter((item) =>
          moment(item.inicio).isSameOrAfter(
            moment(this.filtro.inicio, "DD/MM/YYYY")
          )
        );
      } else if (this.filtro.fim) {
        this.payload = this.payload.filter((item) =>
          moment(item.fim).isSameOrBefore(moment(this.filtro.fim, "DD/MM/YYYY"))
        );
      }

      if (this.filtro.situacao) {
        this.payload = this.payload.filter(
          (item) => item.ativo == (this.filtro.situacao == "Ativo")
        );
      }

      if (this.filtro.usuarioId && this.filtro.usuarioId.usuarioId) {
        this.payload = this.payload.filter(
          (item) => item.usuarioId == this.filtro.usuarioId.usuarioId
        );
      }
    },
    loadPacotes() {
      this.setLoading(true);

      contratosAPI
        .list()
        .then((resp) => {
          this.payload = resp.data;
          this.todosContratos = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter Contratos");
        });
    },
  },
  mounted() {
    this.loadPacotes();
  },

  computed: {
    ...mapGetters(["isFullAdmin", "user"]),
  },
};
</script>
<style lang="scss" scoped>
.status {
  padding: 5px 10px;
  text-align: center;
  border-radius: 10px;
  width: fit-content;
  width: 100px;
}

.ativo {
  background-color: #0080003b;
  border: 1px solid #3aa93a;
  color: #0f2e0f;
}

.inativo {
  background-color: #ff000059;
  border: 1px solid red;
  color: #020202;
}
</style>
